module.exports = __webpack_public_path__ + "static/img/home-new5.7d1fa3d7.jpg";